import { useMutation } from '@tanstack/react-query'
import { startSkillsCollectionCall } from 'api/admin/coach/startSkillsCollectionCall'

export const useStartSkillsCollectionCall = () => {
  return useMutation({
    mutationFn: startSkillsCollectionCall,
  })
}
